// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { PolicyDetailsFacadeService } from '../../../state/policy-details/policy-details.facade';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { readParameterFromRouterState, PolicyDetailResponse } from '@app/core';
import { ActivatedRoute } from '@angular/router';
import { PolicyStatementFacadeService } from '@app/access-management/state/policy-statement.facade';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-policy-details',
    templateUrl: './policy-details.component.html'
})
export class PolicyDetailsComponent implements OnInit, OnDestroy {

    policy$: any;
    destroy$ = new Subject();
    statements$: any;

    constructor(
        private activatedRoute: ActivatedRoute,
        private policyDetailsFacade: PolicyDetailsFacadeService,
        private policyStatementFacade: PolicyStatementFacadeService
        ) {
        const id = readParameterFromRouterState(this.activatedRoute, 'id');
        if (!id) {
          throw new Error('role id not in route');
        }

        this.policyDetailsFacade.initialize(id);
        this.policy$ = this.policyDetailsFacade.policy$;
        this.statements$ = this.policyDetailsFacade.policyStatements$;
    }


    ngOnInit(): void { }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/access-management/policies/policies-list/policy-details/policy-details.component.ts